import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PluginsRouting } from './plugins.routing';

@NgModule({
  imports: [CommonModule, PluginsRouting],
  declarations: [],
})
export class PluginsModule {}
